import type { TFunction } from "i18next";
import * as yup from "yup";
import { peselRegex } from "../static/regex";

export const getPeselSchema = (t: TFunction) =>
  yup.string().matches(peselRegex, { message: t("COMMONS.ERRORS.INCORRECT_PESEL") });
